import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';

export default function TestimonialCard({ name, role, quote, rating = 5, image, delay = 0 }) {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.95 }}
      whileInView={{ opacity: 1, scale: 1 }}
      viewport={{ once: true, margin: "-50px" }}
      transition={{ duration: 0.5, delay }}
      whileHover={{ y: -5 }}
      className="bg-[hsl(var(--soft-grey))] rounded-[12px] p-8 border border-[hsl(var(--natural-oak))]/30 premium-shadow relative flex flex-col h-full"
    >
      <div className="flex gap-1 mb-6">
        {[...Array(5)].map((_, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, scale: 0 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ delay: delay + 0.2 + (i * 0.1), type: "spring" }}
          >
            <Star className={`w-5 h-5 ${i < rating ? 'fill-[hsl(48,89%,70%)] text-[hsl(48,89%,70%)]' : 'text-gray-300'}`} />
          </motion.div>
        ))}
      </div>
      <p className="text-[hsl(var(--charcoal))] italic leading-relaxed mb-8 flex-grow text-lg">"{quote}"</p>
      <div className="flex items-center gap-4 mt-auto">
        <div className="w-12 h-12 rounded-full overflow-hidden border-2 border-[hsl(var(--cream-white))] shadow-sm">
          {image ? (
             <img src={image} alt={name} className="w-full h-full object-cover" />
          ) : (
             <div className="w-full h-full bg-[hsl(var(--warm-sand))] flex items-center justify-center text-lg font-bold text-[hsl(var(--charcoal))]">
               {name.charAt(0)}
             </div>
          )}
        </div>
        <div>
          {/*
            ACCESSIBILITY: was <h4>, but this section's heading is <h2>
            ("Loved by South Africans") with no <h3> in between -- an
            h2 -> h4 skip flagged by the heading-order audit. A
            testimonial author's name isn't part of the document
            outline anyway, so it's now a styled paragraph instead.
          */}
          <p className="font-semibold text-[hsl(var(--charcoal))]">{name}</p>
          <p className="text-sm text-[hsl(var(--charcoal))]/70">{role}</p>
        </div>
      </div>
    </motion.div>
  );
}